import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import type { ModalFooterOnClickHandler } from 'LuxKit/Modal/ModalFooter'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import TierProgressionInfoModalContent from './TierProgressionInfoModalContent'

interface Props {
  tiers: Array<App.LoyaltyTier>
  defaultExpandedTier?: App.LoyaltyTier
  onBookNow?: () => void
  onAddToCart?: () => void
  checkoutDate?: string
}

function TierProgressionInfoModal({ tiers, defaultExpandedTier, onBookNow, onAddToCart, checkoutDate }: Props) {
  const intl = useIntl()
  const programDisplayName = getLoyaltyProgramDisplayName()

  const hasActions = !!(onBookNow || onAddToCart)

  const handleBookNow = useCallback<ModalFooterOnClickHandler>((e, resolve) => {
    resolve()
    onBookNow?.()
  }, [onBookNow])

  const handleAddToCart = useCallback<ModalFooterOnClickHandler>((e, resolve) => {
    resolve()
    onAddToCart?.()
  }, [onAddToCart])

  const modalTitle = intl.formatMessage({
    id: 'Ppqq2OT1K5tZmAwITQNy',
    defaultMessage: '{programName} Status upgrade',
    description: 'Modal title for tier progression info in the loyalty program section',
  }, { programName: programDisplayName })

  const bookNowText = (
    <FormattedMessage
      id="RXnnY1ws1cbaVNnOj246"
      defaultMessage="Book now"
      description="Book now button in tier progression modal in the loyalty section"
    />
  )

  const addToCartText = (
    <FormattedMessage
      id="hs0WtPgRbe6Y_Ho9ClTh"
      defaultMessage="Add to cart"
      description="Add to cart button in tier progression modal in the loyalty section"
    />
  )

  return (
    <Modal
      title={modalTitle}
      primaryActionText={hasActions ? bookNowText : undefined}
      secondaryActionText={hasActions ? addToCartText : undefined}
      onPrimaryActionClick={hasActions ? handleBookNow : undefined}
      onSecondaryActionClick={hasActions ? handleAddToCart : undefined}
    >
      <TierProgressionInfoModalContent
        tiers={tiers}
        defaultExpandedTier={defaultExpandedTier}
        checkoutDate={checkoutDate}
      />
    </Modal>
  )
}

export default TierProgressionInfoModal
